// Public marketing routes that may render BEFORE Firebase Auth resolves.
//
// AuthProvider blanks the entire tree until onAuthStateChanged fires (IndexedDB
// read + a network probe for persisted sessions) — correct for the authenticated
// app, but for paid-ad landing traffic it is seconds of white screen before any
// content. The routes listed here render immediately with `currentUser = null`;
// when auth then resolves, the same public tree re-renders in place (verified:
// these paths render the identical public element for signed-in and signed-out
// users, so there is no flash, redirect, or loop).
//
// Deliberately EXCLUDED: '/' — it is auth-branched (signed-in users are redirected
// to /dash), so pre-auth rendering it would flash the homepage at signed-in users.
// Every path not matched here keeps today's exact blank-until-resolved behavior.
import { resolvePublicSurfacePath } from './publicSurfaces';

// '/pricing' is deliberately ABSENT (PR #991 review finding 3882442393): its
// checkout handler branches on the signed-in user, so rendering it pre-auth
// let a fast Buy click take the anonymous branch for a signed-in visitor.
// Pricing keeps the pre-#988 blank-until-resolved boot; the paid-ad routes
// below are anonymous-checkout by design, so the same hazard does not exist.
const PRE_AUTH_PREFIXES = [
    '/lp/',
    '/assessment',
    '/getstarted',
    '/welcome',
];

export function isPreAuthRenderPath(pathname) {
    if (typeof pathname !== 'string' || !pathname) return false;
    // /report and /report/:messageSlug — but never the shared-report deep link
    // (/report/:projectId/:shareToken) or any other unregistered shape, which
    // resolvePublicSurfacePath rejects.
    if (pathname === '/report' || pathname.startsWith('/report/')) {
        return Boolean(resolvePublicSurfacePath(pathname));
    }
    return PRE_AUTH_PREFIXES.some((prefix) => (
        prefix.endsWith('/') ? pathname.startsWith(prefix) : pathname === prefix || pathname.startsWith(`${prefix}/`)
    ));
}
